import {
  VISIT_KEY_COFFEECHAT,
  VISIT_KEY_FAIRCORP_CLOUD,
  VISIT_KEY_FAIRCORP_HOSTING,
  VISIT_KEY_FAIRCORP_HUB,
  VISIT_KEY_FAIRCORP_TOOLBOX,
  VISIT_KEY_PRIME_DETAILING,
  VISIT_KEY_YOUTH_MEDICAL_OUTREACH,
} from '../constants/visitKeys';

export type HostingSiteStatus = 'live' | 'comingSoon' | 'partner';

export type HostedSite = {
  name: string;
  description: string;
  url?: string;
  /** Stable key for /api/hosting/visits (FairCorp Hub vs Hosting SPA must not share a key). */
  visitKey?: string;
  monthlyVisits: number;
  status: HostingSiteStatus;
};

const hubUrl = import.meta.env.VITE_HUB_URL ?? 'http://fair-corp.com';
const hostingUrl = typeof window !== 'undefined' ? window.location.origin : (import.meta.env.VITE_HOSTING_URL ?? 'http://hosting.fair-corp.com');

export const hostedSites: HostedSite[] = [
  {
    name: 'FairCorp Hosting & Development',
    description: 'This site — development quotes, hosting plans, and the directory of sites FairCorp hosts.',
    url: hostingUrl,
    visitKey: VISIT_KEY_FAIRCORP_HOSTING,
    monthlyVisits: 0,
    status: 'live',
  },
  {
    name: 'FairCorp Hub',
    description: 'FairCorp\'s public portal and service directory.',
    url: hubUrl,
    visitKey: VISIT_KEY_FAIRCORP_HUB,
    monthlyVisits: 0,
    status: 'live',
  },
  {
    name: 'FairCorp Cloud',
    description: 'Secure cloud storage platform by FairCorp. Coming soon.',
    visitKey: VISIT_KEY_FAIRCORP_CLOUD,
    monthlyVisits: 0,
    status: 'comingSoon',
  },
  {
    name: 'FairCorp ToolBox',
    description: 'FairCorp\'s commercial software storefront and staff portal — browse and purchase licensed software, plus internal tools for staff including VPN enrollment.',
    url: 'https://toolbox.fair-corp.com',
    visitKey: VISIT_KEY_FAIRCORP_TOOLBOX,
    monthlyVisits: 0,
    status: 'live',
  },
  {
    name: 'S&O Prime Detailing  ',
    description: 'S&O Prime Detailing is a locally owned mobile detailing business focused on attention to detail and exceptional customer service. We come to you — home or work — with all supplies and a commitment to quality',
    url: 'http://primedetailing.fair-corp.com',
    visitKey: VISIT_KEY_PRIME_DETAILING,
    monthlyVisits: 0,
    status: 'live',
  },
  {
    name: 'CoffeeChat',
    description:
      'A hosted social platform for career conversations — create an account and chat with professionals about careers, new options, and relevant experience.',
    url: 'https://coffeechatcareer.com',
    visitKey: VISIT_KEY_COFFEECHAT,
    monthlyVisits: 0,
    status: 'live',
  },
  {
    name: 'Youth Medical Outreach',
    description:
      'Youth-led emergency response and prevention training for Colorado schools.',
    url: 'https://youthmedicaloutreach.fair-corp.com',
    visitKey: VISIT_KEY_YOUTH_MEDICAL_OUTREACH,
    monthlyVisits: 0,
    status: 'live',
  },
  {
    name: 'Partner Site (Reach Out)',
    description: 'Interested in being hosted by FairCorp? Reach out and we\'ll discuss options.',
    monthlyVisits: 0,
    status: 'partner',
  },
];
